<template>
  <div class="main">
    <van-button type="primary" @click="generateUrl">跳转测试223332</van-button>
  </div>
</template>

<script>
import Vue from 'vue';
import {Toast} from 'vant';
import {Button} from 'vant';

import AES from "@/utils/AES";

Vue.use(Toast);
Vue.use(Button);

export default {
  name: 'index',
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    generateUrl() {
      const params = {
        access_code: 'ulp',
        wxShortLinkDto: {
          path: '/pages/welcome/index',
          query: 'target=%2Fmine%2Fpages%2Fretailers%2Findex%3FentryType%3D2ndreservation%26id%3DULOS2204111718076585%26source1%3D2ndPartyEC%26source2%3DTyreInstallReserve%26source3%3DA00000%26source%3DSelfOwned%26contentName%3DSMS',
          is_expire: true,
          expire_type: 1,
          expire_interval: 10,
          // expire_time: 15,
          env_version: 'trial',
        }
      }
      // V4NVaO5TOQJpLlWMDz%2FLatInBsjuBZdwt6AxEL4NfoKl2HWJoW93uLrAWYOr18z4rJVp6ssdtM6S3jHmxOB0W4e9F2mrJ1XRDFgnrj5PhQ%2F%2FHfwQtNzkjmmBOkwuzTDQ07mSfKRyW89792M7CU52cWZNrktU3YPETYJS0w7RwgrTuZJ8pHJbz3v3YzsJTnZxZk2uS1Tdg8RNglLTDtHCCtO5knykclvPe%2FdjOwlOdnFmTa5LVN2DxE2CUtMO0cIK07mSfKRyW89792M7CU52cWZNrktU3YPETYJS0w7RwgrTuZJ8pHJbz3v3YzsJTnZxZk2uS1Tdg8RNglLTDtHCCtO5knykclvPe%2FdjOwlOdnFmTa5LVN2DxE2CUtMO0cIK07mSfKRyW89792M7CU52cU6k4wFr96rw4AA6UNZlVdFBdsHpUt8Oh5OBiWSdvkCz2BD%2FSMu21xnEgQdBStH3OqwxLtrY4fYmqfW5UDMsXJ8OVB8QH8i8DWoBJjpFHSpxOiO27YNaiGfK4FZAHVN4ag%3D%3D
      var encrypts = AES.encrypt(JSON.stringify(params), '9a5faf9879532529c8517f6a925aa81a');
      // console.log('--encrypts---', encrypts)

      // let params2 = 'FmwN5ZaP+GpCZdDjK6op37IjtthXmNhyzIPkS8hSgkjybKaPXvYZ5TG9krh4S0eNB6QvbsFadPEO/LeIxerkQ/nEtBe4LV5xkbHJ8o/EXPE069wRutl1UYI5Krzy9ot2PD95wIG87Y15x3IHDx6dnetaMH9YLtaBGHjXGYKv0JRNYola7QCWxivnRDXvvWaTOZi/MzR/CQ954xtK/gYigNMRfJCB/zlYXnLQAGEORbantuJAAh09nED0L5GnXt050wdyzRXOGGfDKdp3qihIBYK8kIMH3ClpkxxVngEgd5xMJJtTkuN3pyzuLY/7yGgllhr0vpQz3l21xwfjUNR4hp4aRGPjXFzfVKe3/GvCyNPDXmaNaCHNmCndcph3HFv5fhI0mVCT37GP638Q9DDnTIf9dPCFr+WXwkWVm9PTEo9vi/pZSWIQz9Yae2tfOkXjZYXDhstKOohI722sVTVKcqZdgQT/Syf2amPKhXJp34etuzfhSfEj14rAWAG+nM3EWyfs3CjKxRFbRt1oVI6FGk5B1jnUUIKKscokrQG1SWL1eHObvWPmjezhcAOz8BXd'
      // console.log('--encrypts---', params2)
      // var encrypts2 = AES.decrypt(params2, '9a5faf9879532529c8517f6a925aa81a');
      // console.log('--encrypts3333---', encrypts2)
      this.$router.push({path: `/index?encipheredData=${encodeURIComponent(encrypts)}`})
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  top: 0;
  font-size: 36/10vw;
  display: flex;
  flex-direction: column;

  .bd {
    flex: 1;
    overflow-y: auto;
  }

  .loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 175px;
    height: 100px;
  }

  .loader .loader-item {
    display: block;
    background: #CCCCCC;
    width: 7px;
    height: 10%;
    border-radius: 14px;
    margin-right: 5px;
    float: left;
    margin-top: 25%;
  }

  .loader .loader-item:last-child {
    margin-right: 0;
  }

  .loader .loader-item:nth-child(1) {
    animation: load 2.5s 1.4s infinite linear;
  }

  .loader .loader-item:nth-child(2) {
    animation: load 2.5s 1.2s infinite linear;
  }

  .loader .loader-item:nth-child(3) {
    animation: load 2.5s 1s infinite linear;
  }

  .loader .loader-item:nth-child(4) {
    animation: load 2.5s .8s infinite linear;
  }

  .loader .loader-item:nth-child(5) {
    animation: load 2.5s .6s infinite linear;
  }

  .loader .loader-item:nth-child(6) {
    animation: load 2.5s .4s infinite linear;
  }

  .loader .loader-item:nth-child(7) {
    animation: load 2.5s .2s infinite linear;
  }

  .loader .loader-item:nth-child(8) {
    animation: load 2.5s 0s infinite linear;
  }

  .loader .loader-item:nth-child(9) {
    animation: load 2.5s .2s infinite linear;
  }

  .loader .loader-item:nth-child(10) {
    animation: load 2.5s .4s infinite linear;
  }

  .loader .loader-item:nth-child(11) {
    animation: load 2.5s .6s infinite linear;
  }

  .loader .loader-item:nth-child(12) {
    animation: load 2.5s .8s infinite linear;
  }

  .loader .loader-item:nth-child(13) {
    animation: load 2.5s 1s infinite linear;
  }

  .loader .loader-item:nth-child(14) {
    animation: load 2.5s 1.2s infinite linear;
  }

  .loader .loader-item:nth-child(15) {
    animation: load 2.5s 1.4s infinite linear;
  }

  @keyframes load {
    0% {
      background: #CCCCCC;
      margin-top: 25%;
      height: 10%;
    }
    50% {
      background: #444444;
      height: 100%;
      margin-top: 0%;
    }
    100% {
      background: #CCCCCC;
      height: 10%;
      margin-top: 25%;
    }
  }

}

</style>
